<template>
  <div id="orderinfo" class="orderinfo userbox" v-loading.fullscreen="loading">
    <div class="userTitle">交换卡</div>
    <!--  -->
    <div class="exchangeOrder" v-if="isExchange">
      <div class="exchangeOrderAddress" v-if="addressList!=null">
        <to-address :title='title' :domVisible='dislogType.address' :list='addressItem' :isSet="isSet" @closeDialog="closeDialog" v-if="dislogType.address" />
        <div class="addressShow" :class="isAddShow?'on':''">
          <ul class="addressList">
            <!-- [item._id==list.AddressId?'on':isAdd==index?'on':''] -->
            <li v-for="(item,index) in addressList" :key='index' :class="isAdd==index?'on':''" @click="setOnlyAddress(index,item)">
              <div>
                <div class="addressName">{{item.City}} ({{item.UserName}}收)</div>
                <div class="addressText line_txt2">{{item.Provice|setProvice}} {{item.AddressDetail}}</div>
                <div class="addressPhone">{{item.Mobile}}</div>
              </div>
              <span class="default" v-if="item.IsDefault">默认地址</span>
              <span class="setAddress" @click="setAddress('address',1,item)">修改</span>
            </li>
          </ul>
        </div>
        <div class="setInfoBox space_between" :class="addressCount>0?'':'addressShow'">
          <div class='isShow' @click="IsShow" v-if="addressCount>3">{{isAddShow?'收起':'显示全部地址'}}</div>
          <div class='isShow' v-else></div>
          <div class="setinfo" @click="setAddress('address',0)">添加收货地址</div>
        </div>
      </div>
      <div>
        <div class="order_list order_list_title">
          <div class="order_list_products">卡片</div>
          <div class="order_list_detail">产品名称</div>
          <!-- <div class="order_list_price">卡号</div> -->
          <!-- <div class="order_list_total">交换截止日期</div> -->
         <!--  <div class="order_list_operate">操作</div> -->
        </div>

        <div class="order_list_border exchange_list_border" v-if="list!=null">
          <div class="order_list">
            <div class="order_list_products">
              <span class="order_img"><img :src="list.TitImg+'?imageView2/2/w/160'" /></span>
            </div>
            <div class="order_list_detail">
              <p class="line_txt3">{{list.Title}}</p>
              <span class="order_num">1</span>
              <span class="order_postage">运费：到付</span>
            </div>
           <!--  <div class="order_list_price">
              <span>{{list.ExchangeCardCode}}</span>
            </div> -->
            <!-- <div class="order_list_total">
              <span>{{list.ClosingDate}}</span>
            </div> -->
            <!-- <div class="order_list_operate">
              <span>{{list.Status!=2?'未签名':'在库'}}</span>
            </div> -->
          </div>
        </div>
        <div class="subTotal">
          <el-button class='' type="" @click="IsExchange()">取消兑换</el-button>
          <el-button class='subtn' type="primary" @click="payGo()">确认兑换</el-button>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="userRightSmallBox" v-if="!isExchange">
      <div class="exchangeBox">
        <router-link class="exchangeRecord" :to="{path:'/cypher'}">兑换记录</router-link>
        <img class="exchangeLogo" src="../../../static/images/exchange.png" />
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item class="login_form_item" prop="exchangeCardCode">
            <el-input class="login_ipt" v-model="ruleForm.exchangeCardCode" placeholder="请输入你兑换码" @input="setInput()">
            </el-input>
          </el-form-item>
          <!-- <el-form-item class="login_form_item" prop="password">
            <el-input class="login_ipt" v-model="ruleForm.password" placeholder="请输入你卡密" @input="setInput()">
            </el-input>
          </el-form-item> -->
          <el-button class="exchange_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">兑换</el-button>
        </el-form>
      </div>
    </div>
    <!-- <nonull type='order' text="未找到订单" v-if="isNull" /> -->
  </div>
</template>
<script>
import { getInfo, numAdd, numSub, numMulti } from "@/api/public";
import Nonull from '@/components/nonull'
import ToAddress from '@/components/dialog/address'
export default {
  name: 'orderinfo',
  components: { Nonull, ToAddress },
  data() {
    return {
      isExchange: false,
      loading: false,
      userInfo: getInfo(),
      isNull: false,
      disabled: true,
      isAddShow: false,
      isAdd: 0,
      dislogType: this.$enumInfo.dislogType,
      pi: this.$enumInfo.addressPage.pageindex,
      ps: this.$enumInfo.addressPage.pagesize,
      list: '',
      addressItem: null,
      addressList: null,
      addressCount: 0,
      isSet: false,
      ruleForm: {
        exchangeCardCode: '',
        // password: ''
      },
      rules: {
        exchangeCardCode: [
          { required: true, message: '请输入你兑换码', trigger: 'blur' },
        ],
        // password: [
        //   { required: true, message: '请输入你卡密', trigger: 'blur' },
        // ],
      },
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {

  },
  created() {},
  methods: {
    //获取兑换卡详情
    getExchangeCommodityList() {
      let that=this
      that.ruleForm.MemberId=that.userInfo._id
      let data=that.ruleForm
      that.$post(that.$interface.GetExchangeCommodityByCode,data).then(res=>{
        if(res.Result!=0){
          that.list=res.Data
          that.getAddress()
          that.IsExchange()
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    // 判断input是否有值
    setInput(val) {
      if ( this.ruleForm.exchangeCardCode != '') {
        this.ruleForm.exchangeCardCode= this.ruleForm.exchangeCardCode.toUpperCase()
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.getExchangeCommodityList()
        }
      })
    },
    payGo() {
      let that=this
      let html = "<div>确认兑换该卡</div>"
      this.$alert(html, '确定兑换', {
        customClass: 'alert exchange',
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        lockScroll: false,
        callback: action => {
          that.setOrder()
        }
      });
    },
    setOrder(){
      let that=this
      let addressDetail = that.addressList[that.isAdd];
      let data = {
          memberId: that.userInfo._id,
          addressId: addressDetail._id,
          userName: addressDetail.UserName,
          mobile: addressDetail.Mobile,
          zipCode: '',
          provice: addressDetail.Provice,
          city: addressDetail.City,
          addressDetail: addressDetail.AddressDetail,
          country: addressDetail.Country,
          exchangeCardCode:that.ruleForm.exchangeCardCode,
          password: that.ruleForm.password
        }
      that.$post(that.$interface.CreateExchangeOrder,data).then(res=>{
        if(res.Result!=0){
          that.$router.push({ path: '/cypher' })
        }else{
          that.$message.error(res.Msg);
        }
      })
    },
    IsShow() {
      this.isAddShow = !this.isAddShow
    },
    IsExchange() {
      this.isExchange = !this.isExchange
    },
    setOnlyAddress(val) {
      this.isAdd = val;
      // if (this.ischeck) {
      //   this.upDataOrder()
      // }
    },
    getAddress() {
      let that = this;
      that.loading = true;
      let data = { MemberId: that.userInfo._id, PageIndex: that.pi, PageSize: that.ps }
      that.$get(that.$interface.SearchShippingAddresses, data).then(res => {
        if (res.Result != 0) {
          that.addressList = res.Data;
          that.addressCount = res.Count;
          that.isNull = res.Count > 0 ? false : true;
        } else {
          that.isNull = true;
        }
        that.loading = false;
      })
    },
    setAddress(val, type, obj) {
      if (type == 1) {
        this.title = '修改收货地址'
        this.addressItem = JSON.parse(JSON.stringify(obj))
        console.log(this.addressItem)
      } else {
        this.title = '添加收货地址'
      }
      this.isSet = type > 0 ? false : true;
      this.dislogType[val] = true;
    },
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
      this.getAddress()
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";
@import "../../../static/css/pay.css";
.exchange_list_border .order_list_detail{
  width: 680px;
    margin: 0 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/exchange.vue